import { refCallbackPreventPropagation } from '@cas/utils/vdsHelpers';
import { VdsLink } from '@volt/volt-extended-components-react';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';
import ElementList from '../element-list/ElementList';
import { ValueGetterParams } from 'ag-grid-community';
import { FileLinkModel } from '@cas/config/documents';

export interface FileLinkValue extends Partial<FileLinkModel> {
  fileType: string;
}

export const fileLinkValueGetter = <T extends FileLinkModel>({
  data,
}: ValueGetterParams<T>): FileLinkValue => ({
  downloadUri: data?.downloadUri,
  fileSize: data?.fileSize,
  fileType: 'PDF',
});

export function FileLinkCellRenderer({
  value,
}: CustomCellRendererProps<FileLinkModel, FileLinkValue>): ReactElement | null {
  if (value) {
    const { downloadUri, fileSize: sizeBytes, fileType } = value;

    if (typeof downloadUri !== 'undefined' && typeof sizeBytes !== 'undefined') {
      const megabytes = (sizeBytes / 1024 / 1024).toFixed(1);

      return (
        <ElementList>
          <VdsLink
            value={`${fileType}, ${megabytes}MB`}
            underline={false}
            url={downloadUri}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            variant="primary"
            iconPosition="left"
            informativeIcon="download"
            ref={refCallbackPreventPropagation}
          />
        </ElementList>
      );
    }
  }

  return null;
}

export default FileLinkCellRenderer;
